function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "60.6,55.3 72.4,55.3 66.5,32.5  "
}), React.createElement("path", {
  className: "st0",
  d: "M132.1,6.8H16.7c-5,0-9.1,4.1-9.1,9.1v65.3c0,5,4.1,9.1,9.1,9.1h115.3c5,0,9.1-4.1,9.1-9.1V15.8 C141.2,10.8,137.1,6.8,132.1,6.8z M27,79.7h-8.8V18.1H48v10.4H27v14.6h18.1v10.4H27V79.7z M79,79.7l-3.8-14H57.9l-3.6,14H45 l16.9-61.6h9.3l17.4,61.6H79z M130.2,79.7h-8.8l-17.5-40.2v40.2h-8.1V18.1h8.5l17.8,41.2V18.1h8.1V79.7z"
}));

var SvgFanIcon = function SvgFanIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 96.1",
    style: {
      enableBackground: "new 0 0 150 96.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fan-icon.c2a3c2cc.svg";
export { ForwardRef as ReactComponent };